import { INVESTOR_PRICING_PAGE_HEADLINE } from '../utils/investorPricingView';

export type InvestorPlanId = 'yearly' | 'threeYear';

/** Pre-selected investor plan on /investors/pricing (all viewports). */
export const DEFAULT_INVESTOR_PLAN: InvestorPlanId = 'yearly';

export const INVESTOR_PRICING_FEATURES = [
  'Thesis-matched startups',
  'Access beyond your network',
  'Earlier visibility',
  'Review anonymously',
  'In-platform chat with founder',
  'Deal progress tracker',
] as const;

export const INVESTOR_PRICING_PLUS_FEATURES = [
  'Pay for 2 years, get 3 years',
  'Price locked for 3 years',
  'Includes future Annual Access updates and new features',
] as const;

export const INVESTOR_SUCCESS_FEE = {
  heading: 'We win when you win',
  body: '2% Success Fee only when you invest in startups discovered via PRAIRI.',
} as const;

export const INVESTOR_GUARANTEE_LABEL = '30-day money-back guarantee';

export const INVESTOR_BILLED_YEARLY_LABEL = 'billed yearly';

export const INVESTOR_PRICING_PLANS: Record<
  InvestorPlanId,
  {
    id: InvestorPlanId;
    name: string;
    whyChoose: string;
    whyChooseLines: readonly [string, string];
    price: string;
    compareAtPrice?: string;
    priceNote: string;
    priceNoteLines?: readonly [string, string];
    equivalent?: string;
    saveBadge?: string;
    selectLabel: string;
    featuresHeading: string;
    bestValue?: boolean;
    plusHeading?: string;
    plusFeatures?: readonly string[];
  }
> = {
  yearly: {
    id: 'yearly',
    name: 'Annual Access',
    whyChoose: 'Why choose: For ongoing flexibility.',
    whyChooseLines: ['For ongoing flexibility.', ''],
    price: '$900',
    priceNote: INVESTOR_BILLED_YEARLY_LABEL,
    equivalent: 'Just $75/month',
    selectLabel: 'Select Annual Access',
    featuresHeading: 'Annual plan',
  },
  threeYear: {
    id: 'threeYear',
    name: '3-Year Access',
    whyChoose: 'Why choose: Lock in before price increases.',
    whyChooseLines: ['Lock in before price increases.', ''],
    price: '$1,800',
    compareAtPrice: '$2,700',
    priceNote: 'one payment for 3-year access',
    priceNoteLines: ['one payment', 'for 3-year access'],
    saveBadge: 'Save $900',
    equivalent: 'Just $50/month',
    selectLabel: 'Select 3-Year Access',
    featuresHeading: 'Everything in Annual Plan',
    bestValue: true,
    plusHeading: 'Plus',
    plusFeatures: INVESTOR_PRICING_PLUS_FEATURES,
  },
};

export const INVESTOR_PRICING_HEADLINE = INVESTOR_PRICING_PAGE_HEADLINE;
